import "@fontsource/martel/400.css";
import "@fontsource/martel/700.css";

import wrapWithProvider from "./wrap-with-provider";

import "./src/styles/customFonts.scss";
if (process.env.NODE_ENV === "development") {
  console.log(
    "%c EdgeTag Mock Mode: Bật chế độ giả lập EdgeTag. ",
    "background: #7b5ed4; color: #fff; padding: 4px;",
  );

  window.edgetag = function (...args) {
    console.groupCollapsed(`🚀 EdgeTag Event: ${args[1]}`);
    console.log("Payload:", args[2] || "No payload");
    console.groupEnd();
  };
}

export const wrapRootElement = wrapWithProvider;

// // gatsby-browser.js
// export const onClientEntry = () => {
//   window.addEventListener("ucEvent", function (e) {
//     const detail = e.detail;

//     if (!detail) return;

//     if (detail.type === "EXPLICIT") {

//       // 1. [CHỐNG LẶP VÔ TẬN] 
//       // Kiểm tra xem trang có đang trong trạng thái vừa bị ép reload không?
//       if (sessionStorage.getItem("is_uc_reloading") === "true") {
//         // Tháo cờ xuống để trả lại trạng thái bình thường cho các lần bấm sau
//         sessionStorage.removeItem("is_uc_reloading");
//         // DỪNG LẠI NGAY LẬP TỨC! Không chạy lệnh reload bên dưới nữa.
//         return;
//       }

//       // 2. Kiểm tra điều kiện từ chối
//       const isMarketingDenied = detail.ucCategory && detail.ucCategory.marketing === false;
//       const isUserAction = detail.action === "onDenyAllServices" || detail.action === "onUpdateServices";

//       // 3. Nếu khách hàng thực sự bấm nút từ chối
//       if (isMarketingDenied && isUserAction) {
//         console.log("🛡️ Khách hàng vừa từ chối. Cắm cờ, XÓA COOKIE và tải lại trang...");

//         sessionStorage.setItem("is_uc_reloading", "true");

//         // Nổ mìn xóa sạch các cookie theo dõi phổ biến
//         // document.cookie = "_fbp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//         // document.cookie = "_gcl_au=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

//         window.location.reload(true);
//       }
//     }
//   });
// };
// gatsby-browser.js
export const onRouteUpdate = ({ location, prevLocation }) => {
  console.log("Route updated:", location.pathname);
  // Dùng setTimeout để đợi document.title được cập nhật bởi React Helmet (hoặc Gatsby Head)
  setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gatsby_page_view',
      pagePath: location.pathname,
      pageTitle: document.title // Lúc này chắc chắn sẽ lấy được title mới
    });
  }, 50);
};